import { create } from "zustand";

export type SpeakerDiarizationStatus = "speakerDiarizing" | "inactive";

type UseGlobalSpeakerDiarizationStatus = {
  status: SpeakerDiarizationStatus;
  sessionGeneration: number | null;
  setStatus: (
    status: SpeakerDiarizationStatus,
    sessionGeneration?: number,
  ) => void;
  resetIfCurrentSession: (sessionGeneration: number) => boolean;
};

export const useGlobalSpeakerDiarizationStatus =
  create<UseGlobalSpeakerDiarizationStatus>()((set, get) => ({
    status: "inactive",
    sessionGeneration: null,
    setStatus: (status, sessionGeneration) =>
      set({
        status,
        sessionGeneration:
          status === "speakerDiarizing" ? (sessionGeneration ?? null) : null,
      }),
    resetIfCurrentSession: (sessionGeneration) => {
      if (get().sessionGeneration !== sessionGeneration) return false;
      set({ status: "inactive", sessionGeneration: null });
      return true;
    },
  }));
